var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error404",style:(_vm.img.bg)},[_c('h4',[_vm._v("Opss!")]),_c('img',{attrs:{"src":_vm.img.ico}}),_vm._m(0),_c('p',[_c('router-link',{staticClass:"btn btn-action",attrs:{"to":{ name: _vm.config_app.url_home}}},[_c('translate',[_vm._v("Ir a la página de Inicio")])],1)],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h1',[_vm._v("404"),_c('small',[_vm._v("Página no encontrada")])])
}]

export { render, staticRenderFns }